import React, {useState} from 'react';
import {AiOutlineCloseCircle, AiOutlineFileSearch} from 'react-icons/ai';
import {RiCheckboxCircleLine, RiArrowGoBackLine} from 'react-icons/ri';
import {Container, Row, Col} from 'react-bootstrap'
import './resume.css'

export default function Resume({
    showResume, setShowResume,
    setShowResult, setShowDisclaimer,

    Lens,
    PatientID, SurgeonName, Eye,

    K1, K2, SteepMeridian,
    Sphere, Cylinder, Axis, Vertex,
    AvgMagnitude1, AvgAxis1,
    AvgMagnitude2, AvgAxis2,

    PostopSphere, PostopCylinder, PostopAxis,
    ACD,
    }) {
    
    const [showedDisclaimer, setShowedDisclaimer] = useState(true);
    function confirmInput(){
        if(!showedDisclaimer || localStorage.getItem("stopDisclaimer") !== "true"){
            setShowResume(false);
            document.getElementById('disclaimer').style.display= null;
            setTimeout(() => setShowDisclaimer(true), 50);
            setTimeout(() => setShowResult(true), 1000);
            //setShowedDisclaimer(true);
        }else{
            setShowResume(false);
            setShowResult(true)
        }
    }
    
    if(showResume){
    return (
        <div className='resume'>
            <div className='overlay' onClick={() => setShowResume(false)}>
                resume
            </div>
            <Container className='resumeContent styledBox'>

                <Row>
                    <Row className='hCenter resumeTitle'>
                        <Col className='resumeShadow resumeCol'>
                            <span><AiOutlineFileSearch className='btnIcon'/> Input</span>
                        </Col>
                    </Row>
                </Row>

                <Row className='separator'/>

                <Row className='resumeInput'>

                    <Row className='resumeRow'>
                        <Col className='resumeShadow resumeCol'>
                            <Row className='spansRow resumePatientData'>
                                <span>
                                    <b className='resumeSubtitle'>Patient Data:</b>
                                    &nbsp;&nbsp;&nbsp;Name/ID: <i>{PatientID}</i>  
                                    &nbsp;&nbsp;&nbsp;Surgeon: <i>{SurgeonName}</i>
                                    &nbsp;&nbsp;&nbsp;Eye: <i>{Eye} eye</i>
                                </span>
                            </Row>
                        </Col>
                    </Row>

                    <Row className='resumeRow'>

                        <Col className='resumeShadow resumeCol'>
                            <Row className='spansRow'>
                                <span className='resumeSubtitle'>Pre Operative Data</span>
                                <span>
                                    Keratometric Astigmatism:
                                    <br></br>
                                    K1: <i>{K1}</i>  
                                    &nbsp;&nbsp;K2: <i>{K2}</i>
                                    <br></br>Steep meridian: <i>{SteepMeridian}</i>  
                                </span>
                                <span>
                                    Preoperative Refraction:
                                    <br></br>
                                    Sph: <i>{Sphere}</i>  
                                    &nbsp;&nbsp;Cyl: <i>{Cylinder}</i>
                                    &nbsp;&nbsp;Axis: <i>{Axis}</i>  
                                    <br></br>
                                    Vertex: <i>{Vertex}</i>
                                </span>
                                {/*<span style={{display: (AvgMagnitude1 === "0.00")? 'none' : null}}>
                                    OCT / Scheimpflug / Biometer: 
                                    <br></br>
                                    Avg. Magnitude:<i>{AvgMagnitude1}</i> 
                                    &nbsp;Avg. Axis:<i>{parseInt(AvgAxis1)}</i>
                                </span>*/}
                            </Row>
                        </Col>
                        <Col className='resumeShadow resumeCol'>
                            <Row className='spansRow'>
                                <span className='resumeSubtitle'>Post Operative Data</span>
                                <span>Implanted IOL:<br></br><i>{Lens}</i></span>
                                <span>
                                    Post Operative Refraction:
                                    <br></br>
                                    Sph: <i>{PostopSphere}</i>
                                    &nbsp;&nbsp;Cyl: <i>{PostopCylinder}</i>
                                    &nbsp;&nbsp;Axis: <i>{PostopAxis}</i>
                                    <br></br>
                                    ACD:<i>{ACD}</i>
                                </span>
                                {/*<span>
                                    Measured TCA:
                                    <br></br>
                                    Avg. Magnitude:<i>{AvgMagnitude2}</i> 
                                    &nbsp;Avg. Axis:<i>{AvgAxis2}</i>
                                </span>*/}
                            </Row>
                        </Col>

                    </Row>

                </Row>

                <Row className='separator'/>

                <Row className='resumeButtonsRow'>
                    <Col xs={12} sm={6}>
                        <button className='resumeShadow modifyBtn resumeSubtitle'
                        onClick={() => setShowResume(false)}>
                            <RiArrowGoBackLine className='btnIcon'/> Modify
                        </button>
                    </Col>
                    <Col xs={12} sm={6}>
                        <button className='resumeShadow confirmBtn resumeSubtitle'
                        onClick={() => confirmInput()}>
                            <RiCheckboxCircleLine className='btnIcon'/> Confirm
                        </button>
                    </Col>
                </Row>

                <div className='resumeCloseBtn' onClick={() => setShowResume(false)}><AiOutlineCloseCircle/></div>
            </Container>
        </div>
    )
    }
}

